import React from 'react'

import PropTypes from 'prop-types'

import Svg from '@/ui/Svg'

import IconBase, { Path, Circle } from '../IconBase'

const CadalogIcon = ({ color = 'icon.blue', ...props }) => (
  <IconBase viewBox='0 0 18 18' {...props}>
    <Svg
      xmlns='http://www.w3.org/2000/svg'
      width={18}
      height={18}
      fill='none'
      {...props}
    >
      <Path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14.64 11.098c.4-.287.778-.604 1.128-.95M2.234
         10.148c.351.347.728.665 1.128.952M7.695 3.643V2.008c0-.725.588-1.313
          1.313-1.313v0c.725 0 1.312.588 1.312 1.313v1.636'
      />
      <Circle
        cx={9}
        cy={5.945}
        r={2.625}
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        d='m9.797 8.451 4.435 8.87H16v-3.5l-4.468-8.935A2.832 2.832
         0 0 0 9 3.32v0a2.832 2.832 0 0 0-2.532 1.566L2 13.82v3.5h1.75l4.434-8.869'
      />
      <Path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M11.83 12.51a9.603 9.603 0 0 1-5.674-.007M8.956
         5.945a.044.044 0 1 0 .088 0 .044.044 0 0 0-.088 0'
      />
    </Svg>
  </IconBase>
)

CadalogIcon.propTypes = {
  color: PropTypes.string,
}

export default CadalogIcon
